module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberpoint"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("会员集点")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('el-button', {
    staticClass: "panel-edit-btn__subshopnum",
    staticStyle: {
      "width": "158px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.jumpToPointsExchange($event)
      }
    }
  }, [_vm._v("礼品兑换")]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn",
    on: {
      "click": _vm.creatPoint
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v("新建集点")])])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.origin == 'yirui' ? '.yirui-panel' : 'panel'
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("活动状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.stateChange
    },
    model: {
      value: (_vm.stateValue),
      callback: function($$v) {
        _vm.stateValue = $$v
      },
      expression: "stateValue"
    }
  }, _vm._l((_vm.stateLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.nameChange
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.collectData.result,
      "row-class-name": "el-table__row_fix",
      "id": "memberredcollect"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "scope_cotent_title"
        }, [_vm._v("开始时间")]), _vm._v(_vm._s(_vm._f("removeHMS")(scope.row.start_time)))]), _vm._v(" "), _c('p', [_c('span', {
          staticClass: "scope_cotent_title"
        }, [_vm._v("结束时间")]), _vm._v(_vm._s(_vm._f("removeHMS")(scope.row.expire_time)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集点条件",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("支付满" + _vm._s(_vm._f("formatNumber")(scope.row.obtain_amt)) + "元可集一点")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "礼品详情",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("满" + _vm._s(scope.row.exchange_pt) + "点可兑换" + _vm._s(scope.row.goods_name) + "一份")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status_chn",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "in_person_no",
      "label": "参与人数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.in_person_no || 0))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchange_num",
      "label": "已兑换"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_amt",
      "label": "刺激收益"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(scope.row.total_amt)) + "元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "who_create",
      "label": "活动来源",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showDetail(scope.row)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-dropdown', [_c('span', {
          staticClass: "el-dropdown-link el-dropdown-link__fix"
        }, [_vm._v("\n                更多"), _c('i', {
          staticClass: "el-icon-caret-bottom el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "el-dropdown-menu__fix collect",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          attrs: {
            "disabled": scope.row.can_operate == 1 || scope.row.state == 2 || scope.row.state == 3
          },
          nativeOn: {
            "click": function($event) {
              _vm.editActivity(scope.row)
            }
          }
        }, [_vm._v("修改活动")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          attrs: {
            "disabled": scope.row.can_operate == 1 || scope.row.state == 2 || scope.row.state == 3
          },
          nativeOn: {
            "click": function($event) {
              _vm.stopActivity(scope.row.id)
            }
          }
        }, [_vm._v("停止活动")]), _vm._v(" "), _c('a', {
          attrs: {
            "href": scope.row.promotion_url,
            "download": ""
          }
        }, [_c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          attrs: {
            "command": "3"
          }
        }, [_vm._v("下载宣传物料")])], 1)], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (+_vm.collectData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": +_vm.collectData.count,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "detail_dialog",
    attrs: {
      "visible": _vm.isShowDetail,
      "title": "集点详情"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowDetail = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("目标点数")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v(_vm._s(_vm.detailData.exchange_pt) + "点")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("集点条件")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_vm._v("\n        支付满"), _c('span', {
    staticClass: "orange"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailData.obtain_amt)) + "元")]), _vm._v("可集一点\n        "), (_vm.detailData.obtain_limit == 0) ? _c('span', {
    staticClass: "orange",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("/一次付款可集多点")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("礼品名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.detailData.goods_name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("礼品价格")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailData.goods_amt)) + "元")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("活动时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_vm._v(_vm._s(_vm.detailData.start_time) + " - " + _vm._s(_vm.detailData.expire_time))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 4
    }
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "desc-item"
  }, _vm._l((_vm.detailData.apply_shops), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shop_name) + _vm._s(index < _vm.detailData.apply_shops.length - 1 ? "、" : ""))])
  }))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 20,
      "offset": 4
    }
  }, [_c('div', {
    staticClass: "remark"
  }, [_vm._v("备注：会员在集点满额兑换礼品后，将自动重新集点")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f256ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/memberredpoint/memberredpoint.vue
// module id = 842
// module chunks = 1